module.exports = __webpack_public_path__ + "static/media/TURTLE-BANK-HUSTLER.ee277191.png";